module.exports = __webpack_public_path__ + "static/sponsorship_img-07-e-32cdcf0f7d00f94fa2ea528f0c72e094.jpg";